/*
  Maisie's Munch scrolling banner engine.
  The block renders ONE set of items. This script measures that set, clones it
  until the banner is full at any screen width, and scrolls by exactly one set's
  width so the loop has no visible jump. Speed is in pixels per second, so every
  banner using the same speed moves at the same pace however long its content is.
*/
(function () {
  if (customElements.get('mm-marquee')) return;

  class MMMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-mm-track]');
      this.set = this.querySelector('[data-mm-set]');
      if (!this.track || !this.set) return;

      this.setAttribute('role', 'marquee');
      this.setAttribute('aria-live', 'off');

      this.build = this.build.bind(this);
      this.resizeObserver = new ResizeObserver(() => this.schedule());
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.set);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());
      this.schedule();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }

    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(this.build);
    }

    build() {
      const setWidth = this.set.getBoundingClientRect().width;
      const viewWidth = this.clientWidth;
      if (!setWidth || !viewWidth) return;
      if (setWidth === this.setWidth && viewWidth === this.viewWidth) return;
      this.setWidth = setWidth;
      this.viewWidth = viewWidth;

      this.track.querySelectorAll('[data-mm-clone]').forEach((node) => node.remove());
      const copies = Math.ceil(viewWidth / setWidth) + 1;
      for (let i = 0; i < copies; i++) {
        const clone = this.set.cloneNode(true);
        clone.removeAttribute('data-mm-set');
        clone.setAttribute('data-mm-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('img').forEach((img) => (img.loading = 'eager'));
        clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
      }

      const speed = parseFloat(this.dataset.speed) || 40;
      this.track.style.setProperty('--mm-shift', `-${setWidth}px`);
      this.track.style.setProperty('--mm-duration', `${setWidth / speed}s`);
      this.classList.add('mm-marquee--ready');
    }
  }

  customElements.define('mm-marquee', MMMarquee);
})();
